module.exports = __webpack_public_path__ + "img/logo_anaSeguros.99160dd6.png";